<template>
  <div class="datacomponents">
    <!-- 柱形图3/4 -->
    <img src="../assets/img/backs.png" alt="" class="centerBack" />

    <div class="charts2">
      <div class="chartsBtn">
        <div
          class="chartsbtn-item"
          v-for="(item, index) in columData"
          :key="index"
          @click="amountClick(item, index)"
          :class="{ 'btn-act': activeIndex === index }"
        >
          {{ item.title }}
        </div>
        <div class="downloadPic">
          <img src="../assets/img/dawn.png" alt="" />
        </div>
        <!-- <div class="chartsbtn-item" @click="numberClick">签约数量</div> -->
        <!-- <div class="chartsbtn-item" @click="mianduimian">面对面</div> -->
      </div>
      <div id="myCharts4"></div>
    </div>
    <div class="charts3">
      <div class="chartsBtn">
        <div
          class="chartsbtn-item"
          v-for="(item, index) in powerData"
          :key="index"
          @click="powerClick(item, index)"
          :class="{ 'btn-act': powerIndex === index }"
        >
          {{ item.title }}
        </div>
        <div class="downloadPic">
          <img src="../assets/img/dawn.png" alt="" />
        </div>
        <!-- <div class="chartsbtn-item" @click="numberClick">签约数量</div> -->
        <!-- <div class="chartsbtn-item" @click="mianduimian">面对面</div> -->
      </div>
      <div id="myCharts5"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //项目营销数据模拟
      yxdata: [
        "信华国际商务中心",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期七",
        "星期八",
        "星期九",
        "星期十",
      ],
      activeIndex: 0,
      powerIndex: 0,
      // 柱形图2按钮
      powerData: [
        {
          id: 1,
          title: "全部",
        },
        {
          id: 2,
          title: "电话",
        },
        {
          id: 3,
          title: "微信",
        },
        {
          id: 4,
          title: "面对面",
        },
      ],
      // 柱形图1按钮
      columData: [
        {
          id: 1,
          title: "签约金额",
        },
        {
          id: 2,
          title: "签约数量",
        },
      ],
    };
  },
  mounted() {
    this.drawColumnPorjectCharts();
    this.drawPowerCharts();
  },
  methods: {
    // 签约金额
    amountClick(item, index) {
      this.activeIndex = index;
    },
    // 销售强度
    powerClick(item, index) {
      this.powerIndex = index;
    },
    // 项目营销强度
    drawPowerCharts() {
      let myChart5 = this.$echarts.init(document.getElementById("myCharts5"));
      // 绘制图表
      myChart5.setOption({
        grid: {
          x: 20,
          y: 40,
          x2: 30,
          y2: 20,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            console.log(params);
            // 添加单位处理
            var value = '<span style="color: red;">' + params[1].value + '</span>';
            var day = params[1].axisValue;
            return day + ":" + value + "单位";
          },
        },
        yAxis: {
          type: "category",
          axisLabel: { show: false },
          data: this.yxdata,
          splitLine: {
            // 隐藏y轴网格线
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },

        series: [
          // 背景进度条
          {
            // realtimeSort: true,
            type: "bar",
            data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],

            barWidth: "10px",
            barGap: "-100%", //设置柱形重合的重要步骤
            itemStyle: {
              barBorderRadius: 10,
              color: "#01115E",
            },
            label: {
              show: true,
              color: "#fff",
              formatter: function (params) {
                var labels = [10, 20, 50, 30, 10, 23, 44, 55, 92, 33]
                return labels[params.dataIndex];
              },

              position: "right",
              align: "right",
              offset: [-20, -20],
              valueAnimation: true,
            },
          },
          // 数据柱形条
          {
            type: "bar",
            itemStyle: {
              barBorderRadius: 10,
              color: "#13E44B",
            },
            data: [10, 20, 50, 30, 10, 23, 44, 55, 92, 33],
            barWidth: "8px",
            barGap: "-100%", //设置柱形重合的重要步骤
            label: {
              color: "#5F98CB",
              show: true,
              formatter: "{b}",
              position: "left",
              align: "left",
              offset: [10, -20],
            },
          },
        ],
      });
    },
    //项目营销柱形图
    drawColumnPorjectCharts() {
      let myChart4 = this.$echarts.init(document.getElementById("myCharts4"));
      // 绘制图表
      myChart4.setOption({
        grid: {
          x: 20,
          y: 40,
          x2: 30,
          y2: 20,
        },
        xAxis: {
          type: "value",
          show: false,
        },
        tooltip: {
          trigger: "axis",
          // formatter: "111",
          axisPointer: {
            type: "shadow",
          },
        },
        yAxis: {
          type: "category",
          axisLabel: { show: false },
          data: this.yxdata,
          splitLine: {
            // 隐藏y轴网格线
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },

        series: [
          // 背景进度条
          {
            // realtimeSort: true,
            type: "bar",
            data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],

            barWidth: "10px",
            barGap: "-100%", //设置柱形重合的重要步骤
            itemStyle: {
              barBorderRadius: 10,
              color: "#01115E",
            },
            label: {
              show: true,
              color: "#fff",
              formatter: function (params) {
                var labels = [
                  "第一个",
                  "第二天数",
                  "第三",
                  "第四",
                  "第五代码",
                  "第六",
                  "第七救赎",
                  "第八",
                  "第九",
                  "第十",
                ];
                return labels[params.dataIndex];
              },

              position: "right",
              align: "right",
              offset: [-20, -20],
              valueAnimation: true,
            },
          },
          // 数据柱形条
          {
            type: "bar",
            itemStyle: {
              barBorderRadius: 10,
              color: {
                type: "linear",
                x: 0, // 渐变起始点 x 坐标，取值范围为 0 - 1
                y: 0, // 渐变起始点 y 坐标，取值范围为 0 - 1
                x2: 1, // 渐变结束点 x 坐标，取值范围为 0 - 1
                y2: 0, // 渐变结束点 y 坐标，取值范围为 0 - 1
                colorStops: [
                  {
                    offset: 0, // 渐变颜色起始位置的偏移量，取值范围为 0 - 1
                    color: "#143787", // 起始颜色
                  },
                  {
                    offset: 1, // 渐变颜色结束位置的偏移量，取值范围为 0 - 1
                    color: "#12FF3F", // 结束颜色
                  },
                ],
              },
            },
            data: [10, 20, 50, 30, 10, 23, 44, 55, 92, 33],
            barWidth: "10px",
            barGap: "-100%", //设置柱形重合的重要步骤
            label: {
              color: "#5F98CB",
              show: true,
              formatter: "{b}",
              position: "left",
              align: "left",
              offset: [10, -20],
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.downloadPic {
  width: 35px;
  height: 35px;
  right: 4vh;
  position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #01115d;
  border-radius: 11px;
}
.downloadPic img {
  width: 26px;
  height: 26px;
}
#myCharts5 {
  width: 100%;
  height: 100%;
}
#myCharts4 {
  width: 100%;
  height: 100%;
}

.btn-act {
  background: rgba(0, 93, 255, 0.16) !important;
  box-shadow: inset 0px 1px 80px 0px rgba(49, 184, 255, 0.5) !important;
}
.chartsBtn {
  display: flex;
  align-items: center;
  margin: 30px 0 0 20px;
  position: relative;
  /* background: red; */
}
.chartsbtn-item {
  margin-right: 20px;
  border-radius: 20px;
  padding: 5px 12px;
  color: #31b8ff;
  background: #0a1162;
  cursor: pointer;
}
.charts2 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 10px 0 0;
}
.charts3 {
  flex: 1;
  width: 100%;
  height: 70vh;
  background: rgba(0, 93, 255, 0.16);
  box-shadow: inset 0px 1px 80px 0px rgba(0, 152, 255, 0.5);
  border-radius: 16px;
  border: 1px solid #1d7fff;
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 10px;
}
.columnChart {
  display: flex;
}
.centerBack {
  width: 1200px;
  height: 72.8vh;
  margin-left: 2px;
  position: absolute;
  margin-top: 21px;
}
</style>


// WEBPACK FOOTER //
// src/components/ownerCount.vue